import { useField, useFormikContext } from "formik";

export const useFormInputHelpers = ({
  name,
  shouldHaveErrorBehaviorAfterSubmit,
  helperText,
}) => {
  const [, meta] = useField(name);
  const metaError = name ? meta.error : null;
  const { submitCount } = useFormikContext();

  const shouldDisplayError = Boolean(
    shouldHaveErrorBehaviorAfterSubmit ? submitCount && metaError : metaError
  );

  const finalHelperText = (shouldDisplayError && metaError) || helperText;

  return { shouldDisplayError, finalHelperText };
};
